import type { ConfigType } from '@plone/registry';
import CustomPersonListingItemTemplate from '../components/Blocks/Listings/CustomPersonListingItemTemplate';
import CustomProjectListingItemTemplate from '../components/Blocks/Listings/CustomProjectListingItemTemplate';
import CustomNewsListingItemTemplate from '../components/Blocks/Listings/CustomNewsListingItemTemplate';
import CustomEventListingItemTemplate from '../components/Blocks/Listings/CustomEventListingItemTemplate';

export default function install(config: ConfigType) {
  config.registerComponent({
    name: 'SummaryListingItemTemplate',
    component: CustomPersonListingItemTemplate,
    dependencies: 'saw.persons.person',
  });

  config.registerComponent({
    name: 'SummaryListingItemTemplate',
    component: CustomProjectListingItemTemplate,
    dependencies: 'saw.persons.project',
  });

  config.registerComponent({
    name: 'SummaryListingItemTemplate',
    component: CustomNewsListingItemTemplate,
    dependencies: 'News Item',
  });

  config.registerComponent({
    name: 'SummaryListingItemTemplate',
    component: CustomEventListingItemTemplate,
    dependencies: 'Event',
  });

  return config;
}
